<template>
    <!-- 对话框 -->
    <el-dialog :visible.sync="show" width="500px" :before-close="closeDialog" center>

        <div style="max-height: 50vh ;overflow-y: auto;" class="box">

            <div>
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">订单编号:</span>
                <span>{{ order_details.order_details.billno }}</span>
            </div>
            <div v-if="order_details.order_details.order_mode">
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">订单模式:</span>
                <span>{{ order_details.order_details.order_mode.name }}</span>
            </div>
            <div v-if="order_details.order_details.order_time">
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">下单时间:</span>
                <span>{{ order_details.order_details.order_time.YmdHis }}</span>
            </div>
            <div>
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">起点名称:</span>
                <span>{{ order_details.order_details.start_name }}</span>
            </div>
            <div>
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">寄件人姓名:</span>
                <span>{{ order_details.order_details.send_consumer_name }}</span>
            </div>
            <div>
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">寄件人电话:</span>
                <span>{{ order_details.order_details.send_consumer_phone }}</span>
            </div>

            <div>
                <span style="display: inline-block; width: 100px; text-align: right;margin-right: 5px;">销单原因:</span>
                <el-select v-model="submit_data.remarks" placeholder="请选择销单原因" @visible-change="labelVisibleChange"
                           clearable
                           style="width: 300px;">
                    <el-option v-for="item in options_label_code" :key="item.value" :label="item.label"
                               :value="item.label">
                    </el-option>
                </el-select>
            </div>

            <div style="display: flex; justify-content: space-around;">
                <div style="width: 30%;display: flex;justify-content: center; flex-wrap: wrap;">
                    <span style="display: inline-block; width: 100%;text-align: center;">乘客扣分:</span>
                    <el-input style="width: 80px;margin: 5px auto;"
                              v-model="submit_data.consumer_duty_cancel_point"></el-input>
                </div>
                <div style="width: 30%;display: flex;justify-content: center; flex-wrap: wrap;">
                    <span style="display: inline-block; width: 100%;text-align: center;">司机扣分:</span>
                    <el-input style="width: 80px;margin: 5px auto;"
                              v-model="submit_data.driver_duty_cancel_point"></el-input>
                </div>
                <div style="width: 30%;display: flex;justify-content: center; flex-wrap: wrap;">
                    <span style="display: inline-block; width: 100%;text-align: center;">乘客扣钱(元):</span>
                    <el-input style="width: 80px;margin: 5px auto;"
                              v-model="submit_data.consumer_duty_cancel_amount"></el-input>
                </div>
            </div>


        </div>

        <!-- 对话框底部按钮 -->
        <span slot="footer" class="dialog-footer">
      <el-button @click="salesOrderSubmit" type="danger" v-if="load">销单</el-button>
      <el-button @click="salesOrderSubmit" type="danger" disabled v-else><i class="el-icon-loading"></i></el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>

    </el-dialog>
</template>

<script>
    var _this, district, map, msgDig;
    import axios from 'axios'; // AJAX封装类
    import bus from '../../../common/bus.js'; // AJAX封装类
    import {
        config
    } from '@/utils/config'; // 配置
    export default {
        components: {},
        props: {
            'isShow': Boolean,
            'data': ''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.submit_data.legwork_order_code = _this.data;

                _this.$post(
                    '/legwork/getOrderLegWorkDetails', {
                          legwork_order_code: _this.data,
                        coordinate: '1',
                        synchronization: '1',
                        order_track: '1',
                        order_difference: '1'
                    }
                )
                    .then(res => {

                        _this.order_details = res.data;

                    }).catch(res => {

                });


                _this.onSocket();


            }
        },
        data() {
            return {


                show: false,

                order_details: [],

                options_label_code: [],

                load: true,


                // 表单数据
                submit_data: {
                  legwork_order_code: '',
                    consumer_duty_cancel_point: '0',
                    driver_duty_cancel_point: '0',
                    consumer_duty_cancel_amount: '0',
                    remarks: ''
                }


            };
        },
        created() {

            _this = this;

            // 接收连接Socket的通知
            bus.$on('Socket', msg => {

                _this.onSocket();

            });

        },
        methods: {

            onSocket() {

                // 长连接接收内容
                _this.global.ws.onmessage = function(res) {


                    var resData = JSON.parse(res.data);

                    _this.$driverState(resData);

                    console.log(resData);


                    if (resData.identification == 'adminCancel' && resData.header == 'error') {

                        // 后台销单错误信息
                        if (msgDig) {
                            msgDig.close();
                        }
                        msgDig = _this.$message.error({
                            message: resData.msg,
                            duration: 0,
                            showClose: true
                        });
                        _this.load = true;

                    } else if (resData.header == 'error') {
                        // 接收到弹窗信息

                        _this.$message.error(resData.msg);


                    } else if (resData.identification == 'adminLegworkCancel' && resData.header == 'success') {
                        // 后台销单成功信息

                        _this.$message.success(resData.msg);



                      // 更改axios请求的baseURL
                      axios.defaults.baseURL = config.axios_normalURL;

                      _this.$post(
                              '/order/legworkRefundMoenySubmit', {
                                legwork_order_code: _this.data,
                              }
                      )
                              .then(res => {
                                // 更改axios请求的baseURL
                                axios.defaults.baseURL = config.axios_baseURL;

                              }).catch(res => {

                      });

                      // 更改axios请求的baseURL
                      axios.defaults.baseURL = config.axios_baseURL;




                      _this.closeDialog();

                        setTimeout(() => {
                            _this.$emit('onSubmit');
                        }, 500);


                        _this.load = true;

                    } else if (resData.identification == 'link' && resData.header == 'logout') {
                        // 接收token失效

                        // 关闭socket
                        bus.$emit('firstlog', false);


                    }

                };


            },

            salesOrderSubmit() {

                _this.load = false;

                var sendData = {
                    'ws_mode': 'adminLegworkCancel',
                    'legwork_order_code': _this.submit_data.legwork_order_code,
                    'consumer_duty_cancel_point': _this.submit_data.consumer_duty_cancel_point,
                    'driver_duty_cancel_point': _this.submit_data.driver_duty_cancel_point,
                    'consumer_duty_cancel_amount': _this.submit_data.consumer_duty_cancel_amount,
                    'remarks': _this.submit_data.remarks
                };


                // 发送数据
                _this.global.ws.send(JSON.stringify(sendData));





            },

            labelVisibleChange(val) {

                if (val && _this.options_label_code.length < 1) {
                    // 请求公司管理接口获取公司唯一编码
                    _this.$post(
                        '/label/labelLists'
                    ).then(res => {

                        _this.options_label_code = res.data.admin.order_cancel.label;


                    }).catch((err) => {

                    });
                }
            },


            closeDialog() {

                _this.submit_data = {
                    order_code: '',
                    consumer_duty_cancel_point: '0',
                    driver_duty_cancel_point: '0',
                    consumer_duty_cancel_amount: '0',
                    remarks: ''
                };
                _this.show = false;

                // 关闭时通知App.vue链接Socket
                bus.$emit('appToSocket');
            }


        }
    };
</script>

<style scoped>
    #container_add {
        height: 90%;
        width: 65%;
        float: left;
    }

    .order-model {
        margin: 20px 0;
    }


    .mode-data {

        margin: 20px 0;
    }

    iframe {
        width: 100%;
        border: medium none;
        height: 100%;
    }

    h4 {
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
    }

    h5 {
        font-size: 20px;
        font-weight: normal;
    }

    .text-btn {
        font-size: 18px;
        margin-left: 20px;
        padding: 5px;
        display: block;
    }

    .box > div {
        margin: 20px 0;
    }
</style>